/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { Job } from '../../models/job';

export interface GetJobs$Params {}

export function getJobs(
   http: HttpClient,
   rootUrl: string,
   params?: GetJobs$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Job>> {
   const rb = new RequestBuilder(rootUrl, getJobs.PATH, 'get');
   if (params) {
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Job>;
      })
   );
}

getJobs.PATH = '/api/weather/job';
